
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({ name: 'ReceiptNotePreview' })
export default class extends Vue {
  @Prop({ required: true }) private fdn: any;

  private fmt(v: any) {
    if (v === 0) return '0';
    return v ? String(v) : '';
  }
}
